module.exports = __webpack_public_path__ + "fonts/comfortaa-v27-latin-regular.a54699e9.woff";